<template>
  <div class="oder_management">
    <el-tabs v-model="tabsVal" @tab-click="handleClick" style="display: block">
      <el-tab-pane :label="item.label" :name="item.name" v-for="item in tabList" :key="item.index"></el-tab-pane>
    </el-tabs>
    <div style="display: flex; justify-content: space-between">
      <div style="width: 50%">
        <div class="add-button" v-if="tenantId == '-1'">
          <el-button type="primary" @click="addNewRules" size="small">新增</el-button>
        </div>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <eco-input
          prefix-icon="el-icon-search"
          class="quick-search"
          placeholder="请输入风险维度、风险模板、风险指标"
          :debounce="2000"
          clearable
          v-model="quickSearch"
          @keydown.enter.prevent.native="loadData(1)"
        >
        </eco-input>
        <el-button type="primary" size="mini" slot="reference" class="advanceBtn" @click="loadData(1)">搜索</el-button>
        <el-popover placement="bottom" popper-class="advancedPopover" v-model="showAdvancedSearch" trigger="click">
          <el-form :inline="true" :model="formInline" label-width="80px" class="demo-ruleForm">
            <el-form-item label="风险模板">
              <el-input placeholder="风险模板" v-model="formInline.bo_def" clearable></el-input>
            </el-form-item>
            <el-form-item label="指标">
              <el-input placeholder="指标" v-model="formInline.target_name" clearable></el-input>
            </el-form-item>
            <el-form-item label="消息类型" v-if="tabsVal == 2">
              <el-select v-model="formInline.risk_level" placeholder="请选择状态消息类型" clearable>
                <el-option v-for="item in newsType" :label="item.name" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="formInline.state" placeholder="请选择状态" clearable>
                <el-option label="关" value="0"></el-option>
                <el-option label="开" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-left: 80px">
              <el-button type="primary" @click="loadData(1)">搜索</el-button>
              <el-button @click="showAdvancedSearch = false">关闭</el-button>
            </el-form-item>
          </el-form>
          <el-button v-if="showAdvancedSearch === false" size="mini" slot="reference" class="advanceBtn2">高级搜索</el-button>
          <el-button v-else size="mini" slot="reference" class="advanceBtn2 bgWhite">高级搜索</el-button>
        </el-popover>
      </div>
    </div>

    <div>
      <el-table
        ref="ecoTable"
        :style="{
          height: `${tableMaxHeight}` + 'px'
        }"
        :max-height="tableMaxHeight"
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        border
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="dimension" label="风险维度" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="bo_def" label="风险模板" show-overflow-tooltip> </el-table-column>
        <el-table-column v-if="tabsVal == 1" prop="target_name" label="风险指标" show-overflow-tooltip></el-table-column>
        <el-table-column v-if="tabsVal == 1" prop="target_def" label="风险定义" show-overflow-tooltip> </el-table-column>
        <el-table-column v-if="tabsVal == 2" prop="risk_level" label="风险等级" :formatter="fxdj" show-overflow-tooltip> </el-table-column>

        <el-table-column v-if="tabsVal == 2" prop="reminder_members" label="提醒人" show-overflow-tooltip> </el-table-column>

        <el-table-column v-if="tabsVal == 2" prop="word_template" label="提醒文字模板" show-overflow-tooltip :formatter="wordTemplateFormat"> </el-table-column>
        <el-table-column v-if="tabsVal == 2" prop="remind_word_sys" label="提醒文字" :formatter="remindFormat" show-overflow-tooltip> </el-table-column>
        <el-table-column v-if="tabsVal == 2" prop="remind_way" label="提醒方式" show-overflow-tooltip :formatter="txfs"> </el-table-column>
        <el-table-column v-if="tabsVal == 2" prop="state" label="状态" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.state == '0' ? '关' : scope.row.state == '1' ? '开' : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="操作">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="edit(scope.row.id)">编辑</el-link>
            <el-link type="primary" :underline="false" v-if="tenantId != '-1' && tabsVal == 1" style="margin-left: 16px" @click="refreshMsg(scope.row.id)"
              >刷新数据</el-link
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="page_bean">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 40, 50, 100, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <notice-rules-form
      ref="noticeForm"
      :key="noticeKey"
      :noticeData="noticeData"
      :isEdit="isEdit"
      :tabsVal="tabsVal"
      :show="show"
      @close="close"
    ></notice-rules-form>
    <risk-indicators ref="riskIndicators" :tabsVal="tabsVal" :isEdit="isEdit" @close="loadData()"></risk-indicators>
  </div>
</template>
<script>
import utils from '@/utils.js'
import noticeRulesForm from './noticeRulesForm.vue'
import riskIndicators from './riskIndicators.vue'
import { mapState } from 'vuex'
import styles from '@/assets/css/element-variables.scss'
export default {
  components: { noticeRulesForm, riskIndicators },
  props: {
    width: {
      type: String,
      default: styles.aside_width
    }
  },
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict,
      newsType: (state) => {
        return utils.findDictList('fxdj', state.user.allDataDict)
      }
    })
  },
  data() {
    return {
      height: '100%',
      treeClickKey: '',
      treeClickParentKey: '',
      asideShow: true,
      isExpand: true,
      tabsVal: '1',
      tabList: [
        { label: '任务规则', name: '1' },
        { label: '消息提醒', name: '2' }
      ],
      formInline: {
        dimension: '', //维度
        bo_def: '', //模型
        target_name: '', //指标
        risk_level: '', //消息类型
        state: '' //状态
      },
      showAdvancedSearch: false,
      dateRangeVal: '',
      code: '',
      tableData: [],
      tableMaxHeight: document.body.clientHeight - 250,
      total: 0,
      pageSize: 20,
      currentPage: 1,
      paymentId: '',
      show: false,
      tenantId: '-1',
      noticeData: {},
      noticeKey: 0,
      conditionOperatorOptions: [
        { value: 'GT', label: '大于' },
        { value: 'LT', label: '小于' },
        { value: 'GE', label: '大于等于' },
        { value: 'LE', label: '小于等于' },
        { value: 'EQ', label: '等于' },
        { value: 'NE', label: '不等于' },
        { value: 'LKS', label: '左相似' },
        { value: 'LKE', label: '右相似' },
        { value: 'IN', label: '包含' },
        { value: 'BETWEEN_CONTAIN_BEHIND', label: '介于(含后值)' },
        { value: 'BETWEEN_CONTAIN_FRONT', label: '介于(含前值)' },
        { value: 'BETWEEN', label: '介于(含前后值)' },
        { value: 'BETWEEN_NO_CONTAIN', label: '介于(不含前后值)' }
      ],
      remindWayOptions: [
        { value: 'inner', label: '站内消息' },
        { value: 'dingTalk', label: '钉钉' },
        { value: 'wxEnterprise', label: '微信' },
        { value: 'sms', label: '短信' }
      ],
      chkWeek: [
        { key: '1', value: '星期一' },
        { key: '2', value: '星期二' },
        { key: '3', value: '星期三' },
        { key: '4', value: '星期四' },
        { key: '5', value: '星期五' },
        { key: '6', value: '星期六' },
        { key: '7', value: '星期天' }
      ],
      isEdit: false,
      wdData: [],
      wdProps: {
        children: 'children',
        label: 'target_name'
      },
      quickSearch: ''
    }
  },
  mounted() {
    if (sessionStorage.currentTenantId) {
      this.tenantId = sessionStorage.currentTenantId
    }
    this.getWdData()
    this.loadData()
    this.calcTableHeight()
    this.$root.$on('resize', () => {
      this.calcTableHeight(600)
      this.$nextTick(() => {
        this.$refs.ecoTable.doLayout()
      })
    })
  },
  methods: {
    //tabs切换事件
    handleClick(tab) {
      this.tabsVal = tab.name
      this.treeClickKey = ''
      this.treeClickParentKey = ''
      this.loadData(1)
    },
    //重置搜索
    reset() {
      this.formInline = {
        dimension: '', //维度
        bo_def: '', //模型
        target_name: '', //指标
        risk_level: '', //消息类型
        state: '' //状态
      }
      this.treeClickKey = ''
      this.treeClickParentKey = ''
      this.loadData(1)
    },
    //新增提醒规则
    addNewRules() {
      this.noticeKey += 1
      this.isEdit = false
      this.noticeData = {
        dimension_key: '',
        dimension: '',
        bo_def_key: '',
        bo_def: '',
        target_key: '',
        target_name: '',
        condition_operator: '',
        condition_ctrl_value: '',
        risk_level: '',
        remind_time: '',
        state: '0',
        remind_way: '',
        remind_way_list: [],
        sub_business_reminder_member: [],
        remind_word: '',
        remind_word_diy: '',
        target_def: '',
        word_template: '1',
        reminder_members: ''
      }
      if (this.tabsVal == 1) {
        this.$refs.riskIndicators.openLink()
      } else {
        this.show = true
        this.$refs.noticeForm.resetFields()
      }
    },
    //编辑提醒规则
    edit(id) {
      this.noticeKey += 1
      let apiName = {
        1: '${risk}/rule/business_reminder/',
        2: '${risk}/rule/business_reminder/message/'
      }
      this.$http.get(apiName[this.tabsVal] + id).then((res) => {
        if (res.data) {
          if (res.data.remind_way) {
            let arr = res.data.remind_way.split(',')
            res.data.remind_way_list = arr
          }
          if (res.data.portal_type) {
            let arrs = res.data.portal_type.split(',')
            res.data.portal_type_list = arrs
          }
          this.isEdit = true
          this.noticeData = res.data
          if (this.tabsVal == 1) {
            this.$refs.riskIndicators.openLink(res.data)
          } else {
            this.show = true
            this.$refs.noticeForm.resetFields()
          }
        }
      })
    },
    //刷新数据
    refreshMsg(id) {
      this.loading = true
      this.$http.get('${risk}/rule/business_reminder/refreshMsg/' + id).then((res) => {
        if (res.data) {
          if (res.data.state) {
            this.loading = false
            this.$message.info('刷新数据成功！')
          } else {
            this.loading = false
            this.$message.error('刷新数据失败！')
          }
        } else {
          this.loading = false
        }
      })
    },
    //关闭新增弹窗
    close() {
      this.show = false
      this.loadData()
    },
    //千分位格式化
    numberFormatter(row, column) {
      var val = row[column.property]
      if (val == undefined) {
        return ''
      }
      return utils.dataTransform(val.toString())
    },
    //条件运算格式化
    tjys(row, column) {
      var val = row[column.property]
      let str = ''
      if (val == undefined) {
        return str
      } else {
        this.conditionOperatorOptions.forEach((item) => {
          if (val == item.value) {
            str = item.label
          }
        })
      }
      return str
    },
    //提醒方式格式化
    txfs(row, column) {
      var val = row[column.property]
      let str = ''
      if (val == undefined) {
        return str
      } else {
        let arr = val.split(',')
        arr.forEach((item) => {
          this.remindWayOptions.forEach((items) => {
            if (item == items.value) {
              str += items.label + ','
            }
          })
        })
        str = str.substring(0, str.length - 1)
      }
      return str
    },
    //风险等级格式化
    fxdj(row, column) {
      var val = row[column.property]
      if (val == undefined) {
        return ''
      }
      return utils.findAllDataDict(val, 'fxdj', this.allDataDict)
    },
    //提醒时间转换
    txsj(row, column) {
      var val = row[column.property]
      let str = ''
      if (utils.isEmpty(val)) return ''
      if (val && val.length < 10) {
        return val
      } else {
        let obj = JSON.parse(val)
        if (obj.rdoTimeType == 1) {
          let arr = obj.sampleDate.split(' ')
          str = arr[0] + ' ' + obj.txtDay
        }
        if (obj.rdoTimeType == 2) {
          str = '每天:' + obj.txtDay
        }
        if (obj.rdoTimeType == 4) {
          if (obj.hasOwnProperty('chkWeek')) {
            let arr = obj.chkWeek.split(',')
            let week = ''
            arr.forEach((item) => {
              this.chkWeek.forEach((items) => {
                if (item == items.key) {
                  week = week + items.value + ','
                }
              })
            })
            week = week.substring(0, week.length - 1)
            str = '每周 ' + week + ' ' + obj.txtWeek
          }
        }
        if (obj.rdoTimeType == 5) {
          str = '每月 ' + obj.chkMons + '号 ' + obj.txtMon
        }
      }
      return str
    },
    //表头样式
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      const obj = {
        textAlign: 'center',
        backgroundColor: '#f3f3f3',
        color: '#333'
      }
      return obj
    },
    //列表样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let str = column.label
      if (str && str != undefined) {
        if (str.indexOf('金额') > -1 || str.indexOf('收款') > -1 || str.indexOf('提醒时间') > -1) {
          return 'text-align:right'
        } else {
          return 'text-align:center'
        }
      } else {
        return 'text-align:center'
      }
    },
    //table勾选事件
    handleSelectionChange() {},
    //每页数量调整
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    // 提醒文字模板
    wordTemplateFormat(row, column) {
      var val = row[column.property]
      if (val == '1') return '系统'
      if (val == '2') return '自定义'
      return ''
    },
    // 提醒文字
    remindFormat(row) {
      if (row.word_template == '1') {
        return row.remind_word_sys
      } else if (row.word_template == '2') {
        return row.remind_word_diy
      } else return row.remind_word_sys
    },
    //页数跳转
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 动态计算表格的高度，自适应当前容器
    calcTableHeight(delay) {
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        const tableMin = this.tenantId == '-1' ? 120 : 80
        this.tableMaxHeight = tablePanelHeight - tableMin
      }, delay || 0)
    },
    // 获取维度树
    getWdData() {
      this.$http.get('${risk}/rule/business_reminder/getAllRiskTarget', {}).then((res) => {
        res.data.forEach((item) => {
          item.target_name = item.name
          item.children = JSON.parse(item.children)
        })
        this.wdData = res.data
      })
    },
    //table数据加载
    loadData(it) {
      console.log(123123123)
      this.tableData = []
      let params = {
        pageBean: {
          page: this.currentPage,
          pageSize: this.pageSize,
          total: 0
        }
      }
      if (it == 1) {
        params = {
          pageBean: {
            page: 1,
            pageSize: 20,
            total: 0
          }
        }
      }
      let querys = []
      if (this.tabsVal == 1) {
        querys = [
          {
            group: 'abc',
            operation: 'EQUAL',
            property: 'F_risk_level',
            relation: 'AND',
            value: 'yjtx'
          },
          {
            group: 'abc',
            operation: 'EQUAL',
            property: 'F_risk_level',
            relation: 'OR',
            value: 'fxtx'
          },
          {
            group: 'abc',
            operation: 'EQUAL',
            property: 'F_risk_level',
            relation: 'OR',
            value: 'ybtx'
          },
          {
            group: 'abc',
            operation: 'EQUAL',
            property: 'F_risk_level',
            relation: 'OR',
            value: 'pttx'
          }
        ]
        if (this.quickSearch) {
          querys.push(
            {
              group: 'quick',
              operation: 'LIKE',
              property: 'F_dimension',
              relation: 'AND',
              value: this.quickSearch
            },
            {
              group: 'quick',
              operation: 'LIKE',
              property: 'F_bo_def',
              relation: 'OR',
              value: this.quickSearch
            },
            {
              group: 'quick',
              operation: 'LIKE',
              property: 'F_target_name',
              relation: 'OR',
              value: this.quickSearch
            }
          )
        }
      } else {
        querys = [
          {
            group: 'abc',
            operation: 'EQUAL',
            property: 'F_risk_level',
            relation: 'AND',
            value: 'xxtx'
          }
        ]
      }
      for (let i in this.formInline) {
        if (this.formInline[i] != '') {
          querys.push({
            group: i == 'dimension' ? 'mian' : 'advance',
            operation: 'LIKE',
            property: 'F_' + i,
            relation: i == 'dimension' ? 'OR' : 'AND',
            value: this.formInline[i]
          })
        }
      }
      if (this.treeClickKey) {
        querys.push({
          group: 'mian',
          operation: 'EQUAL',
          property: 'F_target_name',
          relation: 'AND',
          value: this.treeClickKey
        })
      }
      if (this.treeClickParentKey) {
        querys.push({
          group: 'mian',
          operation: 'EQUAL',
          property: 'F_dimension',
          relation: 'AND',
          value: this.treeClickParentKey
        })
      }
      if (querys.length > 0) {
        params.querys = querys
      }
      this.showAdvancedSearch = false
      // if (prop) {
      //   params.sorter = [{ property: prop, direction: sort }];
      // }
      let apiName = {
        1: '${risk}/rule/business_reminder/query',
        2: '${risk}/rule/business_reminder/message/query'
      }
      this.$http.post(apiName[this.tabsVal], params).then((res) => {
        let response = res.data
        this.tableData = response.rows
        this.total = response.total
        this.pageSize = response.pageSize
        this.currentPage = response.page
        this.$refs.ecoTable.doLayout()
      })
    },
    //通过分类树筛选数据
    handleNodeClick(data, node) {
      if (data && data.target_name) {
        this.treeClickKey = data.target_name
      }
      if (node && node.parent && node.parent.label) {
        this.treeClickParentKey = node.parent.label
      } else {
        this.treeClickKey = ''
        this.treeClickParentKey = data.name
      }
      this.loadData(1)
    }
  }
}
</script>

<style scoped>
.col_style {
  height: 100%;
  display: flex;
  align-items: center;
}
.col_style p {
  flex-shrink: 0;
}
/deep/.el-input-group__append button.el-button {
  border-color: transparent;
  background-color: #377cff;
  color: white;
  border-top: 0;
  border-bottom: 0;
}
.button_group {
  height: 40px;
  display: flex;
  justify-content: right;
  align-items: center;
}
.page_bean {
  display: flex;
  justify-content: right;
  align-items: center;
}

/deep/.el-table--scrollable-y .el-table__body-wrapper {
  overflow-y: auto;
  max-height: !important;
}
.quick-search {
  width: 400px;
  height: 50px;
}
.oder_management {
  height: calc(100% - 20px);
  position: relative;
}
.quick-search + .el-divider {
  margin-right: 20px;
}
.advanceBtn {
  float: left;
  height: 32px;
  width: 80px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.advanceBtn2 {
  margin-left: 10px;
  float: left;
  border: 1px solid rgba(41, 124, 249, 100);
  height: 32px;
  background-color: rgba(255, 255, 255, 100);
  color: rgba(41, 124, 249, 100);
  padding: 0;
  width: 80px;
}
</style>
